// global

import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import flatpickr from 'flatpickr'
import store from '../services/store'

// config
import veeconfig from '../../config/runtimeConf/veeconfig.js'
import { French } from 'flatpickr/dist/l10n/fr.js'
import messages from 'vee-validate/dist/locale/fr'

// plugins
import flatPickr from 'vue-flatpickr-component'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import InfiniteLoading from 'vue-infinite-loading'
import Multiselect from 'vue-multiselect'
import Notifications from 'vue-notification'
import { Vue2Dragula } from 'vue2-dragula'
import VueRangedatePicker from 'vue-rangedate-picker'
import VueScrollto from 'vue-scrollto'
import VueYoutube from 'vue-youtube'
import vueVimeoPlayer from 'vue-vimeo-player'
import vueSlider from 'vue-slider-component'
import VueSweetalert2 from 'vue-sweetalert2'
import VueTheMask from 'vue-the-mask'
import VueQuillEditor from 'vue-quill-editor'

// components
import AdditionalFilter from '@/components/utils/AdditionalFilter'
import AppFilter from '@/components/utils/AppFilter'
import Avatar from '@/components/utils/Avatar'
import ColumnsToggles from '@/components/utils/ColumnsToggles'
import DisplayButtonList from '@/components/utils/DisplayButtonList'
import DisplayMenu from '@/components/layout/DisplayMenu'
import EventNotification from '@/components/event/EventNotification'
import EventTracker from '@/components/utils/EventTracker'
import EventTrackerList from '@/components/utils/EventTrackerList'
import GmapInput from '@/components/utils/GmapInput'
import ListFilter from '@/components/utils/ListFilter'
import MultiselectButton from '@/components/utils/MultiselectButton'
import Pagination from '@/components/utils/Pagination'
import RangeChooser from '@/components/utils/RangeChooser'
import Sortable from '@/components/utils/Sortable'
import Spinner from '@/components/utils/Spinner'
import SpinnerRound from '@/components/utils/SpinnerRound'
import StatsCharts from '@/components/utils/StatsCharts'
import Sticky from '@/components/utils/Sticky'
import TableHScroll from '@/components/utils/TableHScroll'
import TagInput from '@/components/utils/TagInput'
import UploadFile from '@/components/utils/UploadFile'
import ViewFileList from '@/components/utils/ViewFileList'
import VInput from '@/components/utils/VInput'
import WysiwygEditor from '@/components/utils/WysiwygEditor'
import RLabel from '@/components/utils/RLabel'

// style
import 'flatpickr/dist/flatpickr.css'
import 'dragula/dist/dragula.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Validator.localize('fr', messages)
flatpickr.localize(French)

Vue.component('AdditionalFilter', AdditionalFilter)
Vue.component('Avatar', Avatar)
Vue.component('AppFilter', AppFilter)
Vue.component('DisplayButtonList', DisplayButtonList)
Vue.component('DisplayMenu', DisplayMenu)
Vue.component('EventNotification', EventNotification)
Vue.component('EventTracker', EventTracker)
Vue.component('EventTrackerList', EventTrackerList)
Vue.component('flatPickr', flatPickr)
Vue.component('GmapCluster', GmapCluster)
Vue.component('GmapInput', GmapInput)
Vue.component('InfiniteLoading', InfiniteLoading)
Vue.component('ListFilter', ListFilter)
Vue.component('Multiselect', Multiselect)
Vue.component('MultiselectButton', MultiselectButton)
Vue.component('Pagination', Pagination)
Vue.component('RangeChooser', RangeChooser)
Vue.component('rangedate-picker', VueRangedatePicker)
Vue.component('Sortable', Sortable)
Vue.component('Spinner', Spinner)
Vue.component('SpinnerRound', SpinnerRound)
Vue.component('ColumnsToggles', ColumnsToggles)
Vue.component('StatsCharts', StatsCharts)
Vue.component('Sticky', Sticky)
Vue.component('TableHScroll', TableHScroll)
Vue.component('TagInput', TagInput)
Vue.component('UploadFile', UploadFile)
Vue.component('ViewFileList', ViewFileList)
Vue.component('VInput', VInput)
Vue.component('vueSlider', vueSlider)
Vue.component('WysiwygEditor', WysiwygEditor)
Vue.component('RLabel', RLabel)

Vue.use(Notifications, {
  max: 5
})
Vue.use(Vue2Dragula, {
  logging: {
    service: false
  }
})

let color = null
if (store && store.getters && store.getters.configs && store.getters.configs.COMPANY_COLOR) {
  color = store.getters.configs.COMPANY_COLOR
}

Vue.use(VueSweetalert2, {
  showCancelButton: true,
  reverseButtons: true,
  animation: false,
  customClass: 'animated zoomInUp xfaster',
  confirmButtonText: 'Confirmer',
  cancelButtonText: 'Annuler',
  confirmButtonColor: color || '#363636',
  width: '36em',
  backdrop: 'rgba(200, 200, 200, 0.55)'
})

Vue.use(VueScrollto, {
  container: '#app',
  duration: 700,
  easing: 'ease',
  offset: -154,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VeeValidate, veeconfig)
Vue.use(VueTheMask)
Vue.use(VueQuillEditor)
Vue.use(VueYoutube)
Vue.use(vueVimeoPlayer)



// WEBPACK FOOTER //
// ./src/utils/GlobalComponents.js